import { State } from './reducer';
import { PayloadAction } from '@reduxjs/toolkit';

export const setIsBodyScrolled = (
	state: State,
	action: PayloadAction<boolean>
) => {
	state.isBodyScrolled = action.payload;
};

export const setViewportWidth = (
	state: State,
	action: PayloadAction<number>
) => {
	state.viewportWidth = action.payload;
};

export const setAppLoaded = (state: State, action: PayloadAction<boolean>) => {
	state.loaded = action.payload;
};

export const setPaymentStatus = (
	state: State,
	action: PayloadAction<State['paymentStatus']>
) => {
	state.paymentStatus = action.payload;
};

export const setLastPaymentIntervalId = (
	state: State,
	action: PayloadAction<NodeJS.Timer | null>
) => {
	state.lastPaymentIntervalId = action.payload;
};
